// extracted by mini-css-extract-plugin
module.exports = {"drawCanvasBox":"drawCanvasBox--vvvS8","hiddenCanvasMarginBox":"hiddenCanvasMarginBox--2DdJq","onceCanvasBox":"onceCanvasBox--iSFc0","stageStyle":"stageStyle--uNaNy"};